<template>
  <export-excel
    type="csv"
    class="export_btn"
    :name="`Counseling list (${$route.params.month}/${$route.params.year}).xls`"
    :data="exportFieldsHandler"
    :footer="[`${$route.params.month}/${$route.params.year}`]"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>Export
  </export-excel>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("Counseling", ["exportFieldsHandler"]),
  },
  data: () => ({}),

  methods: {},
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 150px;
  padding: 5px 15px;
  margin-bottom: 1px;
  cursor: pointer;
}
</style>
